/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useCallback, useMemo } from 'react';
import {
	type JSErrorBoundaryProps,
	JSErrorBoundary,
} from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { getUserLocation } from '@jira/platform__utils-router/src/common/utils/index.tsx';
import { Fallback } from './fallback/index.tsx';

export const SidebarErrorBoundary = (props: JSErrorBoundaryProps): React.JSX.Element => {
	const userLocation = getUserLocation();

	const extraEventData = useMemo(
		() => ({ ...props.extraEventData, userLocation }),
		[props.extraEventData, userLocation],
	);

	const fallback = useCallback(({ error }: { error: Error }) => <Fallback error={error} />, []);
	return <JSErrorBoundary {...props} extraEventData={extraEventData} fallback={fallback} />;
};
